module.exports = __webpack_public_path__ + "static/media/nmsi.00c04aca.png";